import { Text, VStack, Box } from '@chakra-ui/react'
import { useTranslation, Trans } from 'next-i18next'

function OurPartners(): React.ReactElement {
  const { t } = useTranslation('aboutUs')

  return (
    <Box
      as="section"
      sx={{
        w: 'full',
      }}
    >
      <VStack
        spacing={{
          base: 2,
          md: 4,
        }}
        layerStyle="container"
        sx={{
          borderBottom: '1px solid',
          borderColor: 'gray.300',
          textAlign: 'center',
        }}
      >
        <Text
          sx={{
            color: 'gray.600',
            fontWeight: 'medium',
            fontSize: {
              base: 'lg',
              sm: 'xl',
              md: '2xl',
            },
          }}
        >
          {t('ourPartner.title')}
        </Text>
        <Text
          sx={{
            fontSize: {
              base: 'lg',
              sm: 'xl',
              md: '2xl',
            },
          }}
        >
          <Trans t={t} i18nKey="ourPartner.paragraph">
            เรามีพาร์ทเนอร์ทั้ง ด้าน
            <Text
              as="strong"
              sx={{
                color: 'primary.400',
                fontWeight: 'medium',
              }}
            >
              Cyber Security
            </Text>
            และ
            <Text
              as="strong"
              sx={{
                color: 'primary.400',
                fontWeight: 'medium',
              }}
            >
              Network Security
            </Text>
            ทำให้เราสามารถตอบสนองความต้องการ ของลูกค้าได้ทุกด้าน
            และช่วยให้ธุรกิจปฏบัติสอดคล้อง PDPA ได้อย่างสมบูรณ์แบบ
            ตั้งแต่การจัดทำเอกสาร ทางกฎหมาย ไปจนถึงการวางระบบให้มีความปลอดภัย
          </Trans>
        </Text>
      </VStack>
    </Box>
  )
}

export default OurPartners
